export const SOLITAIRE_GAMES = [
  {
    id: 34,
    title: "Tripeaks Solitaire",
    image: "/assets/solitaire/0a522bae-67e1-4eec-95f8-687001cb0190 1.png",
    link: "https://thegameio.ng/solitaire-collection/",
  },
  {
    id: 35,
    title: "Classic Solitaire Challenge",
    image: "/assets/solitaire/28dc5c49-35b5-4baa-9f54-ede11ac65552 1.png",
    link: "https://thegameio.ng/solitaire-collection/",
  },
  {
    id: 36,
    title: "FreeCell Solitaire",
    image: "/assets/solitaire/293c659d-5f99-43bc-a0f0-21b92656e407 1.png",
    link: "https://thegameio.ng/solitaire-collection/",
  },
  {
    id: 37,
    title: "Spider Solitaire",
    image: "/assets/solitaire/2bd63c88-3dd4-478d-a541-62171772af9f 1.png",
    link: "https://thegameio.ng/solitaire-collection/",
  },
  {
    id: 38,
    title: "Pyramid Solitaire",
    image: "/assets/solitaire/4511502c-89a8-4a2c-8c8c-79ef9c321d93 1.png",
    link: "https://thegameio.ng/solitaire-collection/",
  },
  {
    id: 39,
    title: "Yukon Solitaire",
    image: "/assets/solitaire/5a0d77de-6518-4d21-af9e-4b4fd706d8d2 1.png",
    link: "https://thegameio.ng/solitaire-collection/",
  },
  {
    id: 40,
    title: "Golf Solitaire",
    image: "/assets/solitaire/9edfde21-5f33-4427-82b3-f5a4e6d642f4 1.png",
    link: "https://thegameio.ng/solitaire-collection/",
  },
];

export const POPULAR_GAMES = [
  { id: 101, title: "Save The Miner", image: "/assets/popular/10f3b2fe-fce5-4ef3-8bad-96cfbb75f9a6 1.png" },
  { id: 102, title: "Gem Crush", image: "/assets/popular/113cfe21-d024-44b6-af74-5fea6a31f5f8 1.png" },
  { id: 103, title: "Ball Master", image: "/assets/popular/14653d1f-5133-4729-b193-f89887957531 1.png" },
  { id: 104, title: "The Lost Nora", image: "/assets/popular/15577769-6b53-4dda-a516-0162f1b1798b 1.png" },
  { id: 108, title: "Panda Pop", image: "/assets/popular/22b509d4-90c2-4075-8fa5-5a2031720b9f 1.png" },
  { id: 109, title: "Rolling Ball 3D", image: "/assets/popular/23f993c7-8d9f-4a14-af14-030d6fd0b65f 1.png" },
  { id: 112, title: "Dimension Escape", image: "/assets/popular/4a35e633-c65a-4e23-b8e5-13092569da13 1.png" },
  { id: 113, title: "Swipe Soccer 3D", image: "/assets/popular/4eed8565-b04f-4396-abcd-9057bd575b26 1.png" },
  { id: 114, title: "Plinko Pro", image: "/assets/popular/55f4090a-1214-4c7c-b5cb-c7d085fa85f8 2.png" },
  { id: 116, title: "Chicken Road Cross", image: "/assets/popular/704e09a9-404f-4979-9c2a-6af0b750f498 2.png" },
  { id: 118, title: "Black Hole", image: "/assets/popular/84eb758a-0db1-42c7-994d-d890aa8edadb 1.png" },
  { id: 119, title: "Cup & Ball Challenge", image: "/assets/popular/888ac99e-e436-4cde-906a-9c835a8eee66 1.png" },
  { id: 123, title: "Pet Crush", image: "/assets/popular/9a220405-e431-4a68-96c5-cd9daaa16f99 1.png" },
  { id: 125, title: "Neon Bounce", image: "/assets/popular/a5e7f167-92ee-48e8-ab4c-d2b90ede3512 1.png" },
  { id: 127, title: "Scratch Royale", image: "/assets/popular/cef8f69c-f8ed-453a-8f77-dc501fc40cee 1.png" },
  { id: 128, title: "Mystic Mind Reader", image: "/assets/popular/dd0ca19b-cdfc-4e76-8775-9df2e83f57a9 1.png" },
  { id: 129, title: "Sport Quest", image: "/assets/popular/dddfdeb1-a7fe-479a-88d6-157fec8ecaa8 1.png" },
  { id: 133, title: "Stake Mines", image: "/assets/popular/e8b2748a-2d35-4608-84c1-d48a37d11c0b 1.png" },
  { id: 134, title: "Ball In The Hole", image: "/assets/popular/ec076aa3-5bad-41ce-a7c3-0768bf709a3c 1.png" },
  { id: 135, title: "Shadow Escape 3D", image: "/assets/popular/f11c211f-a763-4a3a-aa11-65a3c2e8f4bf 2.png" },
  { id: 136, title: "Lights Out", image: "/assets/popular/f2fe3a32-3222-4acd-89b8-aec7e175d5df 1.png" },
];

export const PUZZLE_SKILL_GAMES = [
  { id: 105, title: "Puzzle Moji", image: "/assets/popular/169e69ff-c945-49a5-8c64-6ede9afbe4d1 1.png" },
  { id: 106, title: "Math Quiz", image: "/assets/popular/18a3c462-067a-40c3-8ded-ede437cdfa4b 1.png" },
  { id: 107, title: "Chess Empire", image: "/assets/popular/229976aa-c7c6-4225-b71a-3fd62112f467 1.png" },
  { id: 110, title: "Block VS Ball", image: "/assets/popular/357c5ac2-c02b-47bb-b647-73d2d4a6d485 1.png" },
  { id: 111, title: "Emoji Merge", image: "/assets/popular/37d7dd40-ee87-4e10-a9a6-5ec0f522be76 1.png" },
  { id: 115, title: "Color Ball Maze", image: "/assets/popular/5f77119b-6b97-4b8a-952b-e7ab5ebe8b92 1.png" },
  { id: 117, title: "Emoji Buster", image: "/assets/popular/77917183-e44f-48d7-9c03-3ac45b877b56 1.png" },
  { id: 120, title: "Gems Quest", image: "/assets/popular/8c946b7a-39d1-4ba0-bde9-624a2c147a6b 1.png" },
  { id: 121, title: "Checkers Master", image: "/assets/popular/97738e91-6f55-4372-96a3-73c65317d667 1.png" },
  { id: 122, title: "Bubble Shooter", image: "/assets/popular/97b8ce37-9fda-4e48-a776-0182553caaf2 1.png" },
  { id: 124, title: "Jewels Quest", image: "/assets/popular/a1523dd5-3179-48ee-855d-7830114887ef 1.png" },
  { id: 126, title: "Onet Animals", image: "/assets/popular/aeba2cae-8978-45dd-aa6a-97e3db2bf7f4 1.png" },
  { id: 130, title: "RocketBot Puzzle", image: "/assets/popular/e2e8215e-d8ed-4157-88f4-adb40f078bb7 1.png" },
  { id: 131, title: "Emoji Crushed", image: "/assets/popular/e30759db-c086-45e3-98d0-b4c7f7f2a50b 1.png" },
  { id: 132, title: "Royal Checker", image: "/assets/popular/e719af60-7b13-4bf3-9667-a359a46820f3 1.png" },
  { id: 137, title: "Marble Switch", image: "/assets/popular/f355e0de-6d0d-4adf-b160-5badb3acc4f5 1.png" },
];

